import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiMfaGetmfacredentialsQueryResponse,
  GetApiMfaGetmfacredentials401,
  GetApiMfaGetmfacredentials403,
} from "../../../types/GetApiMfaGetmfacredentials";

export function getGetApiMfaGetmfacredentialsUrl() {
  return `/api/MFA/GetMFACredentials` as const;
}

/**
 * {@link /api/MFA/GetMFACredentials}
 */
export async function getApiMfaGetmfacredentials(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiMfaGetmfacredentialsQueryResponse,
    ResponseErrorConfig<
      GetApiMfaGetmfacredentials401 | GetApiMfaGetmfacredentials403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiMfaGetmfacredentialsUrl().toString(),
    ...requestConfig,
  });
  return res;
}
